import axios from "@/index";
const brand = {
  state: {
    baseDataBrandList: [],
    brandData: [],
    allBrandInfo: []
  },
  getters: {},
  actions: {
    getBaseDataBrandList: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setBaseDataBrandList",
                (state, { baseDataBrandList: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getBrandInfoById: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit("setBrandInfoById", (state, { brandData: response.data }));
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getAllBrandInfo: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setAllBrandInfo",
                (state, { allBrandInfo: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  mutations: {
    setBaseDataBrandList(state, action) {
      state.baseDataBrandList = action.baseDataBrandList;
    },
    setBrandInfoById(state, action) {
      state.brandData = action.brandData;
    },
    setAllBrandInfo(state, action) {
      state.allBrandInfo = action.allBrandInfo;
    }
  }
};
export default brand;
